import { useCallback, useEffect } from 'react';

/**
 * Subscribes to postMessage events and validates the message
 * URL origin and domain.
 */
const useOnPostMessage = ({ onMessage = () => { }, url = '' }) => {
  const onMessageLocal = useCallback(({ data, origin, source }) => {
    const HTTPS_KEY = 'https://';

    if (!url) {
      return;
    }

    const [webViewOrigin] = url.replace(HTTPS_KEY, '').split('/');
    const domain = `${HTTPS_KEY}${webViewOrigin}`;
    const validDomain = origin === domain;
    if (!validDomain) {
      return;
    }

    onMessage({ data, origin, source });
  }, [url, onMessage]);

  useEffect(() => {
    window.addEventListener('message', onMessageLocal);

    return () => {
      window.removeEventListener('message', onMessageLocal);
    };
  }, [onMessageLocal]);
};

export { useOnPostMessage };
